<ion-card
  class="add-another-promo-row"
  [color]="
    selected === maximum ? 'getm-warning-light' : 'getm-background-light-blue'
  "
  mode="ios"
>
  <ion-grid fixed class="ion-no-padding">
    <ion-row class="ion-justify-content-between">
      <ion-col size="7.5">
        <ion-label class="promo-message" color="getm-neutral-dark">
          {{ 'Labels.add-another-promotion' | translate }}
          <ng-container *ngIf="selected === maximum">
            <ion-text
              color="getm-neutral-light"
              class="limit-reached animated fadeIn fast"
            >
              <ion-icon
                name="getm-warning-fill"
                color="getm-warning-default"
              ></ion-icon>
              {{ 'Labels.limit-reached' | translate }}
            </ion-text>
          </ng-container>
        </ion-label>
      </ion-col>

      <ion-col size="3.9">
        <getm-quantity-selector
          [quantity]="selected"
          [minimo]="minimum"
          [maximo]="maximum"
          [showRemoveBtn]="true"
          (quantityChange)="onQuantityChange($event)"
          (removeProduct)="onRemoveProduct()"
        ></getm-quantity-selector>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-card>
